<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="FinPaymentOrderInfo"
                        :filter_language="['order_status']"
                        :filter_thousandth="['net_total_amount','vender_net_total_amount']"
                        :header="tableHeader"
                        :option="tableOption"
                        @edits="editInfo"
                        @rowdblclick="openEdit"
                        :checkflg="false"
                        ref="singleTable"
                ></wTable>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div>
                        <el-button type="primary" size="mini"  @click.native.prevent="audit()" :disabled="dataDetail.Head.order_status != 0">{{$t('getapi[941]')}}</el-button>
                        <el-button type="primary" size="mini"  @click.native.prevent="reAudit()" :disabled="dataDetail.Head.order_status != 1">{{$t('getapi[1334]')}}</el-button>
                        <el-button type="primary" size="mini"  @click.native.prevent="keep()" :disabled="dataDetail.Head.order_status != 1">{{$t('getapi[1868]')}}</el-button>
                        <el-button type="primary" size="mini"  @click.native.prevent="reKeep()" :disabled="dataDetail.Head.order_status != 2">{{$t('getapi[1869]')}}</el-button>
                        <el-button type="primary" size="mini"  @click.native.prevent="execute()" :disabled="dataDetail.Head.order_status != 0">{{$t('getapi[1902]')}}</el-button>
                        <el-button type="primary" size="mini"  @click.native.prevent="reExecute()" :disabled="dataDetail.Head.order_status != 4">{{$t('getapi[8053]')}}</el-button>
                        <el-button type="primary" size="mini"  @click.native.prevent="getPayMentLists()">{{$t('getapi[8590]')}}</el-button>
                    </div>
                    <div style="width:630px;min-width:630px">
                        <table>
                            <tr>
                                <td style="width:60px;min-width:60px">{{$t('getapi[463]')}}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.order_no" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{$t('getapi[5080]')}}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.vender_currency_code" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{$t('getapi[5100]')}}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.exchange_rate" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{$t('getapi[1861]')}}</td>
                                <td>
                                    <el-input type="text" size="mini" :value="expStatus(dataDetail.Head.order_status)" :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{$t('getapi[5101]')}}</td>
                                <td>
                                    <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.vender_net_total_amount"></el-input>
                                </td>
                                <td>{{$t('getapi[3748]')}}</td>
                                <td>
                                    <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.net_total_amount" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{$t('getapi[1196]')}}</td>
                                <td>
                                    <routejump :urlNo="26" v-if="dataDetail.Head.order_status == 0">
                                    <el-input
                                            v-model="dataDetail.Head.vender_code"
                                            type="text"
                                            readonly
                                            class="mcolor"
                                            size="mini"

                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectvender()"></i>
                                    </el-input>
                                    </routejump>
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.vender_code" v-if="dataDetail.Head.order_status != 0" :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{$t('getapi[1197]')}}</td>
                                <td colspan="3">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.vender_name" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div style="height:600px">
                    <el-tabs :tab-position="'top'" type="" style="margin-top: 5px">
                        <el-tab-pane :label="$t('getapi[5103]')" name="0" id="xdetilpane-0">
                            <vxe-table
                                    :data="dataDetail.Lists"
                                    :highlight-current-row="true"
                                    style="width: 100%; margin-top:3px"
                                    resizable
                                    show-overflow="tooltip"
                                    height="550px"
                                    header-row-class-name="headerclass"
                                    size="mini"
                                    border
                                    ref="singleTable1"
                            >
                                <vxe-table-column show-footer-overflow field="line_no" :title="$t('getapi[1425]')" align="right" width="60"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="invoice_no" :title="$t('getapi[2992]')" width="120"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="po_code" :title="$t('getapi[3854]')" width="120"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="current_payment_amount" :title="$t('getapi[8587]')" width="120" align="right"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="invoice_amount" :title="$t('getapi[8534]')" width="120" align="right"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="remain_amount" :title="$t('getapi[8588]')" width="120" align="right"></vxe-table-column>
                                <vxe-table-column field="iis_invoice_flag" :title="$t('getapi[5087]')" width="120">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.iis_invoice_flag == 0?$t('getapi[2053]'):$t('getapi[2052]')}}</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[3739]')" name="1">
                            <table>
                                <tr>
                                    <td style="width:60px">{{$t('getapi[1228]')}}</td>
                                    <td style="width:150px;">
                                        <el-input type="text" size="mini" v-model="dataDetail.Head.balance_mode_name" :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td style="width:60px">{{$t('getapi[3802]')}}</td>
                                    <td style="width:150px;">
                                        <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.payment_period" :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td style="width:60px">{{$t('getapi[1249]')}}</td>
                                    <td style="width:80px;">
                                        <el-input type="text" size="mini" v-model="dataDetail.Head.tax_code" :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td style="width:60px">{{$t('getapi[1225]')}}</td>
                                    <td style="width:60px;">
                                        <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.tax_rate" :readonly="true" class="readO"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{$t('getapi[1224]')}}</td>
                                    <td>
                                        <el-input type="text" size="mini" v-model="dataDetail.Head.tax_number" :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td>{{$t('getapi[1219]')}}</td>
                                    <td>
                                        <el-input type="text" size="mini" v-model="dataDetail.Head.bank_account_name" :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td>{{$t('getapi[1220]')}}</td>
                                    <td>
                                        <el-input type="text" size="mini" v-model="dataDetail.Head.bank_account_number" :readonly="true" class="readO"></el-input>
                                    </td>
                                </tr>
                            </table>
                        </el-tab-pane>
                    </el-tabs>
                    </div>
                    <div style="width:600px">
                        <table>
                            <tr>
                                <td style="width:60px">{{$t('getapi[1890]')}}</td>
                                <td style="width:80px;">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.create_person" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px">{{$t('getapi[3691]')}}</td>
                                <td style="width:100px;">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.create_date" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px">{{$t('getapi[4043]')}}</td>
                                <td style="width:80px;">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.audit_person" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px">{{$t('getapi[742]')}}</td>
                                <td style="width:100px;">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.audit_date" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="FinPaymentOrderInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[5077]')" queryData="FinPaymentOrderInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <!-- 客户代码 -->
        <selector :isVisible="false" :isBatch=false :selectType="0" :isSplitPage=true
                  :postUrl="'/Finance/PayMent/GetVenderCodePopuDataList'" @callback="getvender" ref="vender"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: '3_paymentoverview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('3_paymentoverview'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                loading: false, // 主表加载状态
                dataDetail:{
                    Head:{
                        order_no:'',
                        customer_code:'',
                        customer_name:'',
                        customer_currency_code:'',
                        exchange_rate:'',
                        balance_mode:'',
                        payment_period:'',
                        customer_net_total_amount:'',
                        create_person:'',
                        create_date:'',
                        audit_person:'',
                        audit_date:'',
                        order_status:'',
                        order_status_name:'',
                        remark:'',
                        bankaccount_name:'',
                        bankaccountnumber:'',
                        tax_rate_code:'',
                        tax_rate:'',
                        tax_id:'',
                        checkout_cycle:'',
                        currency_code_id:'',
                        balance_mode_name:''
                    },
                    Lists:[],
                },
                oldDataDetail: '',
                addoredit: 0,
                btn: {
                    audit: false,
                    reaudit: false,
                    keep:false,
                    rekeep:false
                },
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                code: '',
                oneormore: 1,
                rowindex: -1,
                selectData:[],
                scrollTop:0,
                scrollTop1:0,
            };
        },
        beforeMount(){
            let that = this;
            that.colsort();
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('3_paymentoverview', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd()
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('FinPaymentOrderInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[5077]"),this.$t("getapi[5131]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                console.log('权限' + that.$limits.authority('plv3', 236, 1))
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (that.$limits.authority('plv2', 238, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                else if (that.$limits.authority('plv2', 238, 1) == 2) {
                    if (that.$limits.authority('plv3', 238, 1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 238, 1) == 1) {
                        //编辑级
                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                    }
                    if (that.$limits.authority('plv3', 238, 1) == 2) {
                        //删除级
                        if (!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)) {
                            if (that.dataDetail.Head.order_status > 0) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
                            }
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                    }

                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('3_paymentoverview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'FinPaymentOrderInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/Finance/PayMent/PayMentOverView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.$nextTick(function(){
                        that.$processdata.initForm(that.SelectIndex)
                    });
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this
                if(that.code == row.order_no){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 254, 1)){
                        return
                    }
                    let datacopy = that.dataDetail;
                    for (let i = 0; i < datacopy.Lists.length; i++) {
                        delete datacopy.Lists[i]['_XID'];
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.order_no
                                that.getDetail(row.order_no)
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.order_no
                        that.getDetail(row.order_no)
                    }
                }, 100);
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail;
                for (let i = 0; i < datacopy.Lists.length; i++) {
                    delete datacopy.Lists[i]['_XID'];
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                let date= Common.methods.getDate();
                that.addoredit = 0;
                that.code = ''
                that.dataDetail = {
                    Head: {
                        order_no: '',
                        vender_code: '',
                        vender_currency_code: '',
                        exchange_rate: 0,
                        balance_mode: '',
                        balance_mode_name: '',
                        payment_period: '',
                        net_total_amount: 0,
                        vender_net_total_amount: 0,
                        create_person: '',
                        create_date: '',
                        audit_person: '',
                        audit_date: '',
                        order_status: 0,
                        order_status_name: that.$t('getapi[1422]'),
                        remark: '',
                        vender_name: '',
                        bank_account_name: '',
                        bank_account_number: '',
                        tax_rate: 0,
                        checkout_cycle: 0,
                        tax_number: '',
                        tax_code: ''
                    },
                    Lists:[]
                };
                that.dataDetail = {...that.dataDetail};
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                let that = this;
                let datacopy = that.dataDetail;
                for (let i = 0; i < datacopy.Lists.length; i++) {
                    delete datacopy.Lists[i]['_XID'];
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.getView();
                            if(that.addoredit == 0){
                                that.confirmAdd()
                            } else {
                                that.getDetail(that.code)
                            }
                        });
                } else {
                    if(that.addoredit == 0){
                        that.getView();
                        that.confirmAdd()
                    } else {
                        that.getView();
                        that.getDetail(that.code)
                    }
                }
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "FinPaymentOrderInfo",
                    fromname: that.$t('getapi[5077]'),
                    SelectIndex: that.SelectIndex,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                let parm = that.dataDetail
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/Finance/PayMent/PayMentSaveData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.code = res.UniqueNum
                        that.getDetail(res.UniqueNum)
                    }
                });
            },
            getDetail(code) {
                let that = this;
                that.addoredit = 1
                let parm = {
                    Code: code
                }
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Finance/PayMent/GetPayMentBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                    }
                    loadingInstance.close()
                });
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            Code: that.code,
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/Finance/PayMent/DeletePayment', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                that.getView()
                                that.confirmAdd();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            selectvender(){
                let that = this
                that.$refs.vender.clearInput(true);
            },
            getvender(data){
                let that = this
                console.log(data)
                that.dataDetail.Head.balance_mode = data.balance_mode
                that.dataDetail.Head.balance_mode_name = data.balance_mode_name
                that.dataDetail.Head.bank_account_name = data.bank_account_name
                that.dataDetail.Head.bank_account_number = data.bank_account_number
                that.dataDetail.Head.payment_period = data.checkout_cycle
                that.dataDetail.Head.vender_currency_code = data.currency_code
                that.dataDetail.Head.vender_code = data.relation_vender_code
                that.dataDetail.Head.vender_name = data.vender_name
                that.dataDetail.Head.exchange_rate = data.exchange_rate
                that.dataDetail.Head.tax_code = data.tax_code
                that.dataDetail.Head.tax_number = data.tax_number
                that.dataDetail.Head.tax_rate = data.tax_rate
            },
            audit(){
                let that = this
                let parm = {
                    Code: that.dataDetail.Head.order_no,
                }
                that.$http.urlpost('/Finance/PayMent/AuditPayment', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            reAudit(){
                let that = this
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    vender_code: that.dataDetail.Head.vender_code,
                    LangType:that.$processdata.getLang(),
                }
                that.$http.urlpost('/Finance/PayMent/RAuditPayment', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            keep(){
                let that = this
                let parm = {
                    Code: that.dataDetail.Head.order_no,
                }
                that.$http.urlpost('/Finance/PayMent/KeepAccountsPayment', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            reKeep(){
                let that = this
                let parm = {
                    Code: that.dataDetail.Head.order_no,
                }
                that.$http.urlpost('/Finance/PayMent/CancelKeepAccountsPayment', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            execute(){
                let that = this
                let parm = {
                    Code: that.dataDetail.Head.order_no,
                }
                that.$http.urlpost('/Finance/PayMent/BlankOutPayment', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            reExecute(){
                let that = this
                let parm = {
                    Code: that.dataDetail.Head.order_no,
                }
                that.$http.urlpost('/Finance/PayMent/CancelBlankOutPayment', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            //自动匹配发票
            getPayMentLists(){
                let that = this
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    vender_code: that.dataDetail.Head.vender_code,
                    vender_net_total_amount: that.dataDetail.Head.vender_net_total_amount,
                    exchange_rate: that.dataDetail.Head.exchange_rate,
                    LangType:that.$processdata.getLang(),
                }
                that.$http.urlpost('/Finance/PayMent/GetPayMentLists', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail.Lists = res.DataContent.Lists;
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        // that.getDetail(that.code)
                    }
                });
            },
            expStatus(val){
                let that = this
                if(val == 0){
                    return that.$t('getapi[1422]')//'生成'
                } else if(val == 1){
                    return that.$t('getapi[4643]')//'审核'
                } else if(val == 2){
                    return that.$t('getapi[1868]')//'记账'
                } else if(val == 3){
                    return that.$t('getapi[3754]')//'月结'
                } else {
                    return ''
                }
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 238,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail;
                for (let i = 0; i < datacopy.Lists.length; i++) {
                    delete datacopy.Lists[i]['_XID'];
                }
                let flag =  that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            },
        }
    };
</script>

<style scoped lang="less">
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .el-textarea {
        display: block;
    }
</style>
